<template>
  <div class="timer-container" v-show="loaded" v-b-tooltip.hover :title="videoTooltip ? $t('videosession-end-caption', { date: endHour }) : $t('timer-end', { date: endHour })">
    <span :class="{ 'danger-limit': limitDate && limitExceeded }">{{ time }}</span>
  </div>
</template>

<script>
import moment from 'moment'
import { VBTooltip } from 'bootstrap-vue'

export default {
  components: {
    VBTooltip
  },
  props: {
		id: {
			type: [String, Number],
			required: true
		},
    duration: {
      type: Number,
      required: true
    },
    startTime: {
      type: Date,
      required: false,
      default: new Date()
    },
    videoTooltip: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      loaded: false,
      time: '00:00:00',
      limitDate: null,
      limitExceeded: false,
      elapsedSeconds: 0
    }
  },
  computed: {
		storageSecondsKey: () => `elapsedSeconds_${this.id}`,
    endHour: () => moment(this.limitDate).format('HH:mm')
  },
  methods: {
    saveElapsedSeconds: function (seconds) {
      try {
        localStorage.setItem(this.storageSecondsKey, seconds)
      } catch (e) {
      }
    },
    removeElapsedSeconds: function () {
      try {
        localStorage.removeItem(this.storageSecondsKey)
      } catch (e) {
      }
    }
  },
  created () {
    this.limitDate = moment(this.startTime || new Date()).add(this.duration, 'm').toDate()
    this.elapsedSeconds = parseInt(localStorage.getItem(this.storageSecondsKey)) || 0
    const that = this
    setInterval(() => {
      that.elapsedSeconds = that.elapsedSeconds + 1
      that.saveElapsedSeconds(that.elapsedSeconds)
      const duration = moment.duration(that.elapsedSeconds, 'seconds')
      that.time = `${duration.hours().toString().padStart(2, '0')}:${duration.minutes().toString().padStart(2, '0')}:${duration.seconds().toString().padStart(2, '0')}`
      that.limitExceeded = that.elapsedSeconds > (that.duration * 60)
      that.loaded = true
    }, 1000)
  }
}
</script>

<style lang="scss">
  .timer-container {
    background-color: white;
    /* box-shadow: $custom-shadow-sm; */
    border-radius: 25px;
    border-color: $blue;
    padding: 10px 15px;
		position: absolute;
		top: 1rem;
		right: 1rem;
  }

  .timer-container > span {
    color: black;
  }

  .danger-limit {
    border-color: $red !important;
    animation: blinker 1.5s linear infinite;
    color: $red !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/utils/Timer.vue